import { render, staticRenderFns } from "./IPCROPCRUploaderComponent.vue?vue&type=template&id=12440e36&"
import script from "./IPCROPCRUploaderComponent.vue?vue&type=script&lang=js&"
export * from "./IPCROPCRUploaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports